import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-textarea-input',
    templateUrl: './textarea-input.component.html',
    styleUrls: ['./textarea-input.component.css'],
    standalone: false
})
export class TextareaInputComponent extends BaseFormInput {
}
